import { LayoutElement, isLayoutTableFieldElement } from "@entaconsulting/form";
import { FieldRenderProps, useField } from "react-final-form";
import getColumnPointingName from "../utils/getColumnPointingName";
import useColumnEdited from "./useColumnEdited";

const useDynamicField = <T>(
  name: string,
  autoPointing: boolean | undefined = true
): FieldRenderProps<T> => {
  const {
    input: { value: rootElement },
  } = useField<LayoutElement>("element");

  const columnEdited = useColumnEdited();

  const newPointingName =
    columnEdited && isLayoutTableFieldElement(rootElement) && autoPointing
      ? getColumnPointingName(name, columnEdited)
      : name;

  return useField(newPointingName);
};

export default useDynamicField;
